// Shared enums for the referral form / receipt.
// Keep in lockstep with clinical_notes.models.Referral.CADRE_CHOICES and
// HealthFacility.FACILITY_TYPE_CHOICES.

export const FACILITY_TYPES = [
  { value: 'hospital', label: 'Hospital' },
  { value: 'specialist', label: 'Specialist Clinic' },
  { value: 'clinic', label: 'Clinic' },
  { value: 'health_centre', label: 'Health Centre' },
  { value: 'aid_post', label: 'Aid Post' },
]

export const FACILITY_TYPE_LABEL = Object.fromEntries(
  FACILITY_TYPES.map((t) => [t.value, t.label]),
)

export const CADRES = [
  { value: 'specialist', label: 'Specialist / Consultant' },
  { value: 'medical_officer', label: 'Medical Officer' },
  { value: 'registrar', label: 'Registrar' },
  { value: 'resident', label: 'Resident Medical Officer' },
  { value: 'heo', label: 'Health Extension Officer (HEO)' },
  { value: 'nurse', label: 'Registered Nurse' },
  { value: 'midwife', label: 'Midwife' },
  { value: 'chw', label: 'Community Health Worker (CHW)' },
  { value: 'apo', label: 'Aid Post Orderly' },
  { value: 'other', label: 'Other' },
]

export const CADRE_LABEL = Object.fromEntries(
  CADRES.map((c) => [c.value, c.label]),
)
